/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ITokenURI, ITokenURIInterface } from "../ITokenURI";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ITokenURI__factory {
  static readonly abi = _abi;
  static createInterface(): ITokenURIInterface {
    return new utils.Interface(_abi) as ITokenURIInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITokenURI {
    return new Contract(address, _abi, signerOrProvider) as ITokenURI;
  }
}
